var Reverb = window.Reverb || {};

Reverb.Cart = function () {
  var cartQuantitySelector = '[data-cart-quantity]';
  var paymentSelectionForm = '[data-payment-selection-form]';

  function init() {
    bindQuantityChange();
    bindPaymentSelectionChange();
  }

  function moveCartItemToWatchList(domId, message, destinationContainer, content, messageDisplayDelay) {
    if (!messageDisplayDelay) { messageDisplayDelay = 1000; }

    Reverb.UI.spinWithMessage('#' + domId, message);
    setTimeout(function () {
      var elem = $('#' + domId);
      elem.slideUp('fast', function () {
        var parent = $(this).parent();
        $(this).remove();
        if (parent.children().length == 0) {
          parent.remove();
        }
      });
      $(destinationContainer).prepend(content);
    }, messageDisplayDelay);
  }

  function bindQuantityChange() {
    $(document).on('change', cartQuantitySelector, function () {
      submitForm(this);
    });
  }

  function bindPaymentSelectionChange() {
    $(document).on('change', paymentSelectionForm, function () {
      submitForm(this);
    });
  }

  function submitForm(changedEl) {
    var select = $(changedEl);
    var form = select.closest('form');
    form.submit();
  }

  return {
    init: init,
    moveCartItemToWatchList: moveCartItemToWatchList
  };
}();

$(Reverb.Cart.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/cart.js